import React, { useState } from 'react';
import { Icon } from '@fikasio/react-ui-components';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { useAddActivityMutation } from 'services/activities/api';
import { Activity } from 'services/activities/types';
import ActivitiesList from './ActivitiesList';
import ActivitiesCalendar from './ActivitiesCalendar/ActivitiesCalendar';
import SelectionBar from 'components/UI/SelectionBar';
import AddActivityButton from './AddActivityButton';

const ActivitiesView = ({
  activities,
  date,
  onActivityClick,
}) => {
  const { t } = useTranslation();
  const [viewMode, setViewMode] = useState('CALENDAR');
  const [selectedActivities, setSelectedActivities] = useState<Activity[]>([]);

  const [createActivity] = useAddActivityMutation();

  const addActivity = async activity => createActivity(activity);

  const handleSelectActivity = activity => {
    const isActivityAlreadySelected = selectedActivities.find(a => a.id === activity.id);
    if (isActivityAlreadySelected) {
      setSelectedActivities([
        ...selectedActivities.filter(a => a.id !== activity.id),
      ]);
    } else {
      setSelectedActivities([
        ...selectedActivities,
        activity,
      ]);
    }
  };

  let activityView;
  if (viewMode === 'LIST') {
    activityView = (
      <ActivitiesList
        activities={activities}
        date={date}
        onActivityClick={onActivityClick}
        onActivitySelect={handleSelectActivity}
        onAddActivity={addActivity}
        onSelectAllActivities={activitiesArray => setSelectedActivities(activitiesArray)}
        selectedActivities={selectedActivities}
      />
    );
  } else {
    activityView = (
      <ActivitiesCalendar
        date={date}
        onActivityClick={onActivityClick}
      />
    );
  }

  return (
    <>
      <div
        style={{
          textAlign: 'left',
        }}
      >
        <AddActivityButton
          onClick={onActivityClick}
          style={{
            float: 'right',
            marginRight: 0,
          }}
        />
        <Button
          active={viewMode === 'LIST'}
          onClick={() => setViewMode('LIST')}
          variant="outline-secondary"
        >
          <Icon name="list" size="1x" />
        </Button>
        <Button
          active={viewMode === 'CALENDAR'}
          onClick={() => setViewMode('CALENDAR')}
          variant="outline-secondary"
        >
          <Icon name="calendar-alt" size="1x" />
        </Button>
      </div>
      { activityView }
      {
        selectedActivities.length > 0 && (
          <SelectionBar>
            <Icon
              name="times"
              onClick={() => {
                setSelectedActivities([]);
              }}
              style={{
                cursor: 'pointer',
                marginRight: 10,
                width: 25,
              }}
            />
            <b>
              {t('xSelectedActivities', { count: selectedActivities.length })}
            </b>
          </SelectionBar>
        )
      }
    </>
  );
}

export default ActivitiesView;
